import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "revico-community-talk-media"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "onClick"]
const _hoisted_5 = {
  key: 0,
  class: "revico-community-talk-media-modal"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "revico-community-talk-media-modal--movie",
  muted: "",
  autoplay: "",
  controls: "",
  loop: ""
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "動画を再生するには、videoタグをサポートしたブラウザが必要です。", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 画像・動画がない場合は要素ごと表示しない "),
    ($props.movies.length > 0 || $props.images.length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
          _createCommentVNode(" 動画 "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.movies, (movie, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "revico-community-talk-media-movie"
            }, [
              _createElementVNode("img", {
                class: "revico-community-talk-media-movie--thumbnail-img",
                src: movie.thumbnailUrl
              }, null, 8 /* PROPS */, _hoisted_2),
              _createElementVNode("div", {
                class: "revico-community-talk-media-movie--thumbnail-play-button",
                onClick: ($event: any) => ($setup.openModal(movie.movieUrl, 'movie'))
              }, null, 8 /* PROPS */, _hoisted_3)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _createCommentVNode(" 画像 "),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.images, (image, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "revico-community-talk-media-image"
            }, [
              _createElementVNode("img", {
                class: "revico-community-talk-media-image--img",
                src: image.imageUrl,
                onClick: ($event: any) => ($setup.openModal(image.imageUrl, 'image'))
              }, null, 8 /* PROPS */, _hoisted_4)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["CustomModal"], { ref: "modalComponent" }, {
      contents: _withCtx(() => [
        ($setup.modalMediaUrl)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              ($setup.modalMediaType === 'image')
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: $setup.modalMediaUrl,
                    class: "revico-community-talk-media-modal--image"
                  }, null, 8 /* PROPS */, _hoisted_6))
                : _createCommentVNode("v-if", true),
              ($setup.modalMediaType === 'movie')
                ? (_openBlock(), _createElementBlock("video", _hoisted_7, [
                    _createElementVNode("source", { src: $setup.modalMediaUrl }, null, 8 /* PROPS */, _hoisted_8),
                    _hoisted_9
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */)
  ], 64 /* STABLE_FRAGMENT */))
}